// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"a4afb2c1","630":"29d33c2d"}[chunkId] + ".chunk.js";
};